<div class="network-indicator" [class]="qualityClass" [pTooltip]="tooltipText" tooltipPosition="bottom">
    <div class="icon-container">
        <i [class]="iconClass"></i>
        <span *ngIf="!status?.isOnline" class="slash-overlay">/</span>
    </div>
    <span class="status-text">{{ statusText }}</span>
</div>
